'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _uuid = require('uuid');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Event = function () {
  function Event() {
    (0, _classCallCheck3.default)(this, Event);
    this.subscribers = [];
  }

  (0, _createClass3.default)(Event, [{
    key: 'sub',
    value: function sub(event, fn) {
      var id = (0, _uuid.v4)();
      this.subscribers = [].concat((0, _toConsumableArray3.default)(this.subscribers), [{
        id: id,
        event: event,
        fn: fn
      }]);
      return this.unsub.bind(this, id);
    }
  }, {
    key: 'unsub',
    value: function unsub(subscriberID) {
      this.subscribers = [].concat((0, _toConsumableArray3.default)(this.subscribers)).filter(function (_ref) {
        var id = _ref.id;
        return id !== subscriberID;
      });
    }
  }, {
    key: 'pub',
    value: function pub(event) {
      for (var _len = arguments.length, data = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        data[_key - 1] = arguments[_key];
      }

      this.subscribers.forEach(function (sub) {
        if (sub.event !== event) return;
        sub.fn.apply(sub, data);
      });
    }
  }]);
  return Event;
}();

exports.default = new Event();